import { render, staticRenderFns } from "./HistorialInfo.vue?vue&type=template&id=c3225772&scoped=true&"
import script from "./HistorialInfo.vue?vue&type=script&lang=js&"
export * from "./HistorialInfo.vue?vue&type=script&lang=js&"
import style0 from "./HistorialInfo.vue?vue&type=style&index=0&id=c3225772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3225772",
  null
  
)

export default component.exports